import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { QueryArticlesContext } from "../../contexts/QueryArticlesContext";
import styles from "./Logo.module.css";

export const Logo = ({ inHeader }) => {
  const { setPage } = useContext(QueryArticlesContext);
  return (
    <Link
      onClick={() => setPage(1)}
      to="/"
      className={`${inHeader ? styles.header_logo : styles.footer_logo}`}
    >
      <span className={styles.logo_text}>The Agentic</span>
    </Link>
  );
};
